export const LOAD_MODAL = "LOAD_MODAL";
